module.exports = __webpack_public_path__ + "img/branch-tianjin.e15776d1.jpg";